import routeParams from 'helpers/routeParams'

const GET_ACTIONS_LIST = 'dofe-bo/actions/GET_ACTIONS_LIST'
const GET_ACTIONS_LIST_SUCCESS = 'dofe-bo/actions/GET_ACTIONS_LIST_SUCCESS'
const GET_ACTIONS_LIST_FAIL = 'dofe-bo/actions/GET_ACTIONS_LIST_FAIL'
const REMOVE_ACTIONS = 'dofe-bo/actions/REMOVE_ACTIONS'
const SET_PARAMS = 'dofe-bo/actions/SET_PARAMS'

const initialState = {
  list: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ACTIONS_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_ACTIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        count: Number(action.headers['x-total-count']),
        pages: Math.ceil(
          Number(action.headers['x-total-count']) / state.limit
        ) || state.pages
      }
    case GET_ACTIONS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        list: [],
        error: action.error
      }
    case SET_PARAMS:
      return {
        ...state,
        limit: action.options.limit !== undefined
          ? action.options.limit
          : state.limit,
        offset: action.options.offset !== undefined
          ? action.options.offset
          : state.offset,
        filter: action.options.filter !== undefined
          ? action.options.filter
          : state.filter,
        sort: action.options.sort !== undefined
          ? action.options.sort
          : state.sort
      }
    case REMOVE_ACTIONS:
      return initialState
    default:
      return state
  }
}

export function getParticipantActions(params = {}, baseFilter, id) {
  return {
    types: [GET_ACTIONS_LIST, GET_ACTIONS_LIST_SUCCESS, GET_ACTIONS_LIST_FAIL],
    promise: client =>
      client.get(
        `api/participants/${id}/actions?${routeParams(params, baseFilter)}`
      )
  }
}

export function getAwardLeaderActions(params = {}, baseFilter, organizationId, personId) {
  return {
    types: [GET_ACTIONS_LIST, GET_ACTIONS_LIST_SUCCESS, GET_ACTIONS_LIST_FAIL],
    promise: client =>
      client.get(
        `api/organizations/${organizationId}/contact/${personId}/actions?${routeParams(params, baseFilter)}`
      )
  }
}

export function getAssessorActions(params = {}, baseFilter, organizationId, personId) {
  return {
    types: [GET_ACTIONS_LIST, GET_ACTIONS_LIST_SUCCESS, GET_ACTIONS_LIST_FAIL],
    promise: client =>
        client.get(
            `api/organizations/${organizationId}/assessor/${personId}/actions?${routeParams(params, baseFilter)}`
        )
  }
}

export function getOrganizationActions(params = {}, baseFilter, id) {
  return {
    types: [GET_ACTIONS_LIST, GET_ACTIONS_LIST_SUCCESS, GET_ACTIONS_LIST_FAIL],
    promise: client =>
      client.get(
        `api/organizations/${id}/actions?${routeParams(params, baseFilter)}`
      )
  }
}

export function getAwardActions(params = {}, baseFilter, id) {
  return {
    types: [GET_ACTIONS_LIST, GET_ACTIONS_LIST_SUCCESS, GET_ACTIONS_LIST_FAIL],
    promise: client =>
      client.get(`api/awards/${id}/actions?${routeParams(params, baseFilter)}`)
  }
}

export function removeActions() {
  return {
    type: REMOVE_ACTIONS
  }
}

export function setActionsParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}
